import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    console.log('AuthCallback - Processing OAuth callback...');
    console.log('AuthCallback - Current URL:', window.location.href);
    console.log('AuthCallback - URL hash:', window.location.hash);
    console.log('AuthCallback - URL search:', window.location.search);
    console.log('AuthCallback - User state:', { user, loading });

    // Check if we have an error in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    if (error) {
      console.error('OAuth error:', error, errorDescription);
      // Redirect to login with error
      navigate('/auth/login?error=' + encodeURIComponent(errorDescription || error));
      return;
    }

    // If we have a user, redirect to dashboard
    if (user && !loading) {
      console.log('AuthCallback - User authenticated, redirecting to dashboard');
      navigate('/dashboard');
      return;
    }

    // If still loading, wait
    if (loading) {
      console.log('AuthCallback - Still loading auth state...');
      return;
    }

    // If no user after loading is complete, something went wrong
    if (!user && !loading) {
      console.log('AuthCallback - No user found after OAuth callback, redirecting to login');
      navigate('/auth/login?error=' + encodeURIComponent('Authentication failed. Please try again.'));
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500 mx-auto"></div>
          <h2 className="mt-6 text-xl font-medium text-gray-900">
            Completing sign in...
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Please wait while we complete your authentication.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
